export const LayoutModeEnum = {
    MODAL: 'modal',
    DEFAULT: null
};
  
export const EnableModeEnum = {
    FULL: 'full',
    SHRINK: 'shrink',
    DEFAULT: null
};
  
export const DisplayContentModeEnum = {
    GREETING: 'gentooGreeting',
    PRODUCT_SINGLE: 'productSingle',
    PRODUCT_HORIZONTAL_LIST: 'productHorizontalList',
    PRODUCT_VERTICAL_LIST: 'productVerticalList',
    SIMPLE_LIST: 'simpleList'
};


